import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useNavigate, Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faTrash } from '@fortawesome/free-solid-svg-icons'

import config from '../config/config'
import NavigationBar from '../components/NavigationBar'
import AdminNavBar from '../components/Admin/AdminNavBar'
import Footer from '../components/Footer/Footer'
import { AuthContext } from '../contexts/AuthContext'
import { useAuth } from '../contexts/AuthContext'
import {
  LOGIN_PATH,
  MANAGE_EXTERNAL_LINK_NEW_PATH,
  MANAGE_EXTERNAL_LINK_PATH,
} from '../config/routes'
import { setFlashMessage } from '../contexts/WebsiteContext'
import { Table, Button } from 'react-bootstrap'

const ManageExternalLinks = () => {
  const { token } = useAuth()
  const { t } = useTranslation()

  const navigate = useNavigate()
  const { logout } = useContext(AuthContext)

  const [externalLinks, setExternalLinks] = useState([])

  useEffect(() => {
    const fetchExternalLinks = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}external-link`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        setExternalLinks(response.data)
      } catch (error) {
        //console.error('Error webservice call:', error);

        if (error.response && error.response.status === 401) {
          logout()
          navigate(LOGIN_PATH)
        } else if (error.response) {
          setFlashMessage(t('ERROR_MESSAGE'), 'error')
        }
      }
    }

    fetchExternalLinks()
  }, [token, logout, navigate, t])

  const handleDelete = (id) => {
    // handle delete functionality here
  }

  return (
    <div>
      <NavigationBar />
      <AdminNavBar />
      <h1>{t('MANAGE_EXTERNAL_LINKS_TITLE')}</h1>
      <div className="p-3">
        <Link
          to={MANAGE_EXTERNAL_LINK_NEW_PATH}
          className="btn btn-primary btn-margin-10"
        >
          {t('ADD')}
        </Link>

        <Table bordered className="rdb-table">
          <thead>
            <tr>
              <th>Id</th>
              <th>{t('LABEL')}</th>
              <th>{t('URL')}</th>
              <th>{t('AFFILIATE_LINK')} ?</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {externalLinks.map((link) => (
              <tr key={link.id}>
                <td style={{ textAlign: 'center' }}>{link.id}</td>
                <td style={{ textAlign: 'center' }}>{link.labelFr}</td>
                <td style={{ textAlign: 'center' }}>
                  <a href={link.urlFr}>{link.urlFr}</a>
                </td>
                <td style={{ textAlign: 'center' }}>
                  {link.isAffiliateLink ? t('YES') : t('NO')}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <Link
                    to={`${MANAGE_EXTERNAL_LINK_PATH.replace(':id', link.id)}`}
                    className="btn btn-sm btn-primary"
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </Link>
                  <Button
                    variant="primary"
                    onClick={() => handleDelete(link.id)}
                    className="btn-sm"
                    style={{ marginLeft: '10px' }}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <img
        className="img-fluid"
        src="/images/photos/95cc8f97-0f60-4275-a019-d2f30f928658.jpg"
        alt="La carrière de marbre de Sost"
      />
      <Footer />
    </div>
  )
}

export default ManageExternalLinks
